import React, { useContext } from "react";
import {
  Grid,
  Box,
  Button,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import SettingsContext from "../../Context/SettingsContext";
import { saveSettings } from "../../common/help-functions";
import { hasCentralSystemUrl } from "../../common/central-system-url";
import { OCPP_PROTOCOLS, PROTOCOL_LABELS } from "../../ocpp-core/protocol";

const MainSettings = () => {
  const { settingsState, setSettingsState } = useContext(SettingsContext);
  const centralSystemUrl = settingsState.mainSettings.centralSystemUrl || "";
  const hasCentralSystemUrlError =
    centralSystemUrl.trim() === "";

  const changeValue = (field, value) =>
    setSettingsState({
      ...settingsState,
      mainSettings: { ...settingsState.mainSettings, [field]: value },
    });

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={9}>
          <TextField
            fullWidth
            label="OCPP Server url"
            size="small"
            variant="outlined"
            name="centralSystemUrl"
            value={centralSystemUrl}
            required
            error={hasCentralSystemUrlError}
            helperText={hasCentralSystemUrlError ? "OCPP Server url is required." : " "}
            onChange={(e) => changeValue(e.target.name, e.target.value)}
            placeholder="ws://localhost:5000"
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Charge Point ID"
            size="small"
            variant="outlined"
            name="chargePointId"
            value={settingsState.mainSettings.chargePointId}
            onChange={(e) => changeValue(e.target.name, e.target.value)}
          />
        </Grid>
        <Grid item xs={2.5}>
          <FormControl fullWidth>
            <InputLabel>OCPP Version</InputLabel>
            <Select
              value={settingsState.mainSettings.OCPPversion}
              label="OCPP Version"
              size="small"
              name="OCPPversion"
              onChange={(e) => changeValue(e.target.name, e.target.value)}
            >
              {OCPP_PROTOCOLS.map((protocol) => (
                <MenuItem key={protocol} value={protocol}>
                  {PROTOCOL_LABELS[protocol]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Basic Auth password (security profile 1/2)"
            size="small"
            variant="outlined"
            type="password"
            name="basicAuthPassword"
            value={settingsState.mainSettings.basicAuthPassword || ""}
            onChange={(e) => changeValue(e.target.name, e.target.value)}
            helperText="Optional. Username is the Charge Point ID."
            autoComplete="new-password"
          />
        </Grid>
        <Grid item xs={6.5}></Grid>
        <Grid item xs={2.5}>
          <TextField
            fullWidth
            label="RFID Tag"
            size="small"
            variant="outlined"
            name="RFIDTag"
            value={settingsState.mainSettings.RFIDTag}
            onChange={(e) => changeValue(e.target.name, e.target.value)}
          />
        </Grid>
        <Grid item xs={9.5}></Grid>
        <Grid item xs={2.5}>
          <FormControl fullWidth>
            <InputLabel>Number of connectors</InputLabel>
            <Select
              value={settingsState.mainSettings.numberOfConnectors}
              label="Number of connectors"
              size="small"
              name="numberOfConnectors"
              onChange={(e) => changeValue(e.target.name, e.target.value)}
            >
              <MenuItem value={1}>One Connector</MenuItem>
              <MenuItem value={2}>Two Connectors</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={9.5}></Grid>
        <Grid item xs={2}>
          <Button
            startIcon={<SaveIcon />}
            variant="contained"
            disabled={!hasCentralSystemUrl(centralSystemUrl)}
            onClick={() => saveSettings(settingsState)}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MainSettings;
